
const samples = [
    {
        name:'CR78 Rim',
        file: 'samples/cr78/Rim_Orig_CR78.wav'
    },
    {
        name:'CR78 OH',
        file: 'samples/cr78/OH_1_Orig_CR78.wav'
    },
    {
        name:'CR78 Bongo',
        file: 'samples/cr78/Bongo_Hi1_Orig_CR78.wav'
    },
    {
        name:'CR78 CowBell',
        file: 'samples/cr78/Cowb_Orig_CR78.wav'
    },
    {
        name:'Clap',
        file: 'samples/clap.wav'
    },
    {
        name:'Snare',
        file: 'samples/snare.wav'
    },
    {
        name:'Tom',
        file: 'samples/tom.wav'
    },
    {
        name:'Custom 1',
        file: 'samples/click1.wav'
    },
    {
        name:'Blop 1',
        file: 'samples/CLICKHIGH.wav'
    },
    {
        name:'Blop 1',
        file: 'samples/CLICKLOW.wav'
    },
    {
        name:'mpc60 78 kick',
        file: 'samples/BD CR78 MPC60 05.wav'
    },
    {
        name:'mpc60 78 clave',
        file: 'samples/Clave CR78 MPC60 10.wav'
    },
    {
        name:'mpc60 78 ch',
        file: 'samples/CH CR78 B MPC60 07.wav'
    },
    {
        name: 'sub kick',
        file: 'samples/Tight Kick 1.wav'
    }
];



export default samples;